import React, { PureComponent } from 'react';

import { Th } from '../../../components/shared/customTable.styled';
import OrderContainer from '../../../components/shared/table/OrderContainer';

export default class HeaderUsersTable extends PureComponent {

  state = {
    current: 'nome',
    sort: 'ASC'
  }

  onChangeOrder = (tag) => {
    let newSort = "ASC";
    if (tag === this.state.current) {
      newSort = this.state.sort === "ASC"? "DESC" : "ASC";
    }
    this.setState({ current: tag, sort: newSort }, () => {
      const tagSort = newSort === "ASC"? tag : `-${tag}`;
      this.props.changeOrder(tagSort);
    })
  }

  render() {
    const { current, sort } = this.state;
    return (
      <tr>
      <Th width="7rem" maxWidth="7rem" uppercase>
          <OrderContainer sort={sort} current={current} tag="master" changeCurrent={this.onChangeOrder}>Tipo</OrderContainer>
        </Th>
        <Th width="3rem" minWidth="3rem" uppercase></Th>
        <Th width="22rem" minWidth="22rem" uppercase>
          <OrderContainer sort={sort} current={current} tag="nome" changeCurrent={this.onChangeOrder}>Nome</OrderContainer>
        </Th>
        <Th width="12rem" minWidth="12rem" uppercase>
          <OrderContainer sort={sort} current={current} tag="funcao" changeCurrent={this.onChangeOrder}>Função</OrderContainer>
        </Th>
        {(this.props.condition === "POSPAGO" && this.props.typeUser === "MASTER") && (
        <>
            <Th width="6rem" minWidth="6rem" align="center" uppercase>
              Editar limite disponível
            </Th>
            <Th width="8rem" minWidth="8rem" align="center" uppercase>
              Limite disponível
            </Th>
            <Th width="6rem" minWidth="6rem" align="center" uppercase>
              Utiliz.
            </Th>
            <Th width="6rem" minWidth="6rem" align="center" uppercase>
              Dispon.
            </Th>
        </>)}
        <Th width="7rem" maxWidth="7rem" uppercase>Status</Th>
      </tr>
    )
  }
}
